export function safeAuthReturnTo(value: unknown, fallback = '/dashboard'): string {
  if (typeof value !== 'string') return fallback
  if (!value.startsWith('/') || value.startsWith('//')) return fallback
  if (value.includes('\\') || /[\r\n]/.test(value)) return fallback

  const [path] = value.split(/[?#]/, 1)
  if (path === '/sign-in' || path === '/register') return fallback

  return value
}
